import React from 'react'
import { Link, } from "react-router-dom";

const Footer = () => {
  
  return (
    <>
      <footer id="footer" data-aos="fade-up" class="footer">
        <div class="footer-top">
          <div class="container">
            <div class="row">
              <div class="col-lg-4 footer-info">
                <h3>ColudMinds</h3>
                <p>
                To empower businesses with intelligent, secure, and scalable technology solutions that drive growth and efficiency. We strive to enhance digital transformation by providing innovative solutions, AI-driven automation,  to help organizations stay ahead in a rapidly evolving digital world.

With a strong focus on customer satisfaction, reliability, and continuous innovation, we aim to build long-term partnerships and create future-ready solutions that make technology seamless, accessible, and impactful for businesses of all sizes.
                </p>
              </div>

              <div class="col-lg-4 footer-links">
                <h4>Useful Links</h4>
                <ul>
                  <li>
                    <i class="fa-solid fa-chevron-right"></i>
                    <Link className="nav-link" to="/"
                                    >Home</Link
                                  >
                  </li>
                  <li>
                    <i class="fa-solid fa-chevron-right"></i>
                    <Link className="nav-link" to="/about">About us</Link>
                  </li>
                  <li>
                    <i class="fa-solid fa-chevron-right"></i>
                    <Link className="nav-link" to="/service"
                                    >Services</Link
                                  >
                  </li>
                  <li>
                    <i class="fa-solid fa-chevron-right"></i>
                    <Link className="nav-link" to="/industries">Industries We Serve</Link>
                  </li>
                  <li>
                    <i class="fa-solid fa-chevron-right"></i>
                    <Link className="nav-link" to="/technologies">Tech Stack</Link>
                  </li>
                </ul>
              </div>

              <div class="col-lg-4 footer-contact">
                <h4>Contact Us</h4>
                <p>
                  Setu Heights<br />
                  Abrama,Valsad<br />
                  Gujarat,India<br />
                  <strong>Phone: </strong>+91 9725955592<br />
                  <strong>Email: </strong>contact@cloudmindstech.in<br />
                </p>

                <div class="social-links">
                  <a href="#" class="facebook"
                    ><i class="fa-brands fa-facebook"></i
                  ></a>
                  <a href="#" class="whatsapp"
                    ><i class="fa-brands fa-whatsapp"></i
                  ></a>
                  <Link to="https://www.instagram.com/cloud_mindstech" class="instagram"
                    ><i class="fa-brands fa-instagram"></i
                  ></Link>
                  <Link to="https://www.linkedin.com/in/cloudmindstech" class="linkedin"
                    ><i class="fa-brands fa-linkedin"></i
                  ></Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="copyright_container">
          <div class="copyright">
            &copy; Copyright <strong>ColudMinds</strong>. All Rights Reserved
          </div>
        </div>
      </footer>
     {/* <footer id="footer" data-aos="fade-up" class="footer">
        <div class="footer-top">
          <div class="container">
            <div class="row">
              <div class="col-lg-4 footer-info">
                <h3>ColudMinds</h3>
                <p>
                To empower businesses with intelligent, secure, and scalable technology solutions that drive growth and efficiency. We strive to enhance digital transformation by providing innovative solutions, AI-driven automation,  to help organizations stay ahead in a rapidly evolving digital world.

With a strong focus on customer satisfaction, reliability, and continuous innovation, we aim to build long-term partnerships and create future-ready solutions that make technology seamless, accessible, and impactful for businesses of all sizes.
                </p>
              </div>

              <div class="col-lg-4 footer-links">
                <h4>Useful Links</h4>
                <ul>
                  <li>
                    <i class="fa-solid fa-chevron-right"></i>
                    <Link className="nav-link" to="/"
                                    >Home</Link
                                  >
                  </li>
                  <li>
                    <i class="fa-solid fa-chevron-right"></i>
                    <Link className="nav-link" to="/about">About us</Link>
                  
                  </li>
                  <li>
                    <i class="fa-solid fa-chevron-right"></i>
                    <Link className="nav-link" to="/service"
                                    >Services</Link
                                  >
                  </li>
                  <li>
                    
                    <i class="fa-solid fa-chevron-right"></i>
                    <Link className="nav-link" to="/industries">Industries We Serve</Link>
                  </li>
                  <li>
                    <i class="fa-solid fa-chevron-right"></i>
                    <Link className="nav-link" to="/technologies">Tech Stack</Link>
                  </li>
                </ul>
              </div>

              <div class="col-lg-4 footer-contact">
                <h4>Contact Us</h4>
                <p>
                  Setu Heights<br />
                  Abrama,Valsad<br />
                  Gujarat,India<br />
                  <strong>Phone: </strong>+91 9725955592<br />
                  <strong>Email: </strong>contact@cloudmindstech.in<br />
                </p>

                <div class="social-links">
                  <a href="#" class="facebook"
                    ><i class="fa-brands fa-facebook"></i
                  ></a>
                  <a href="#" class="whatsapp"
                    ><i class="fa-brands fa-whatsapp"></i
                  ></a>
                  <Link to="https://www.instagram.com/cloud_mindstech" class="instagram"
                    ><i class="fa-brands fa-instagram"></i
                  ></Link>
                  <Link to="https://www.linkedin.com/in/cloudmindstech" class="linkedin"
                    ><i class="fa-brands fa-linkedin"></i
                  ></Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="copyright_container">
          <div class="copyright">
            &copy; Copyright <strong>ColudMinds</strong>. All Rights Reserved
          </div>
        </div>
      </footer> */}
    </>
    
  )
}

export default Footer
